import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectMatchingEnabled } from '../../store/selectors/matchingSelectors';
import { fetchMatchingStatus } from '../../store/thunks';

/** Lets the matching pages open only while the feature is switched on; otherwise returns to the floor plan. */
export function MatchingGate({ children }: { children: React.ReactNode }) {
  const dispatch = useAppDispatch();
  const enabled = useAppSelector(selectMatchingEnabled);

  React.useEffect(() => {
    void dispatch(fetchMatchingStatus());
  }, [dispatch]);

  if (enabled === false) return <Navigate to="/floor-plan" replace />;
  return <>{children}</>;
}
